export const useFilterOptions = async (params) => {
  const { data: filterOptions } = await useFetchSafelyCached("tests/filter-options", {
    params,
  });
  return filterOptions.value?.data;
};

/**
 * Fetchs all the products from backend api.
 * @param {Partial<{ hiddenTests: boolean; clinic: number; service_type[number]: string }>} params - Request parameters.
 * @returns Products list.
 */
export const useFetchProductList = async (params) => {
  return useFetchSafelyCached("tests/list", {
    params,
  });
};

const EXCLUDED_EXTRA_SERVICES = ["everywhere-nurse-service", "home-test-kit"];

export const useFetchClinicTests = async (data, serviceType, extraServices = []) => {
  let url = `tests/list?clinic=${data}`;

  if (data === "everywhere-nurse-service") {
    url = `tests/list?page=1&sort=order-asc&service_type[0]=${data}`;
  } else if (serviceType) {
    const params = new URLSearchParams();
    params.append("service_type[0]", serviceType);
    const filteredExtraServices = extraServices.filter((service) => !EXCLUDED_EXTRA_SERVICES.includes(service));
    filteredExtraServices.forEach((service, index) => {
      params.append(`service_type[${index + 1}]`, service);
    });
    url += `&${params.toString()}`;
  }

  return useFetchSafely(() => url);
};

export const useFetchCategoryDetails = async (slug) => {
  const { data: categoryDetails } = await useFetchSafelyCached(`categories/${slug}`);
  return categoryDetails.value.data;
};

export const useFetchSubCategoryLists = async (slug, locale) => {
  const { data: subCategoryLists } = await useFetchSafelyCached(`sub-categories/${slug}`, { locale });
  return subCategoryLists.value?.data ?? [];
};

export const useCheckEverywhereService = (lat, lng) => {
  return useFetchSafely(() => `/check-everywhere-service`, {
    body: { latitude: lat, longitude: lng },
    method: "POST",
  });
};

export const useEveryWhereRegionPriceList = async () => {
  return await useFetchSafely(() => `/everywhere-service/regions`);
};

export const useSubscribeOutOfStock = async (data) => {
  return useFetchSafely(() => `subscribe/out-of-stock`, {
    method: "POST",
    body: data,
    useErrorBoundary: true,
  });
};
